/**
 * @fileoverview Agent definition for chapter-drafter-enhanced-v2.
 *
 * This is a COMPOSITE agent that orchestrates a two-step pipeline:
 * 1. chapter-drafter-v2-neutral (or single-chapter-drafter for short-form):
 *    Writes a neutral draft focused on continuity, pacing, and beats.
 * 2. style-aligner-v2: Applies the active style guide to the neutral draft.
 *
 * Each step has full attention on a single concern — structure first, then
 * style — instead of the model trying to satisfy both at once.
 *
 * @category writing.content.generation
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-drafter-enhanced-v2',
  kind: 'composite',
  name: 'Enhanced Chapter Drafter',
  description: 'Drafts a chapter as neutral prose (focused on continuity, pacing, and beats), then applies the active style guide. Each step does one thing.',
  category: 'writing',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata ---
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-01',
    lastUpdated: '2026-05',
    usedBy: [
      'use-chapter-drafter-enhanced-v2.ts',
    ],
    // Composite agents specify which primitives they orchestrate
    composedOf: [
      'chapter-drafter-v2-neutral',
      'single-chapter-drafter',
      'style-aligner-v2',
    ],
    relatedAgents: [
      'chapter-drafter-v2-neutral',
      'single-chapter-drafter',
      'style-aligner-v2',
      'chapter-drafter-v2',
    ],
    taxonomyPath: 'writing.content.generation',
  },
};
